
import { NewModal } from '@/utils/modal'
import { markRaw } from 'vue'
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

type ModalState = 'init' | 'opened' | 'closed' | 'moving'

@Options({})
export default class ModalBottomDynamicPage extends Vue {
  @Prop({ required: true, type: Object }) readonly modal!: NewModal
  @Prop({ required: true, type: Function }) readonly removeModal!: (modal: NewModal) => void

  state: ModalState = 'init'
  elementId = ''
  element: HTMLElement | null = null
  elementHeight = 0
  elementBottom: number | null = null
  dynamicComponent: any = null

  created() {
    this.elementId = `modal-bottom-dynamic-page-${this.modal.index}`
    this.dynamicComponent = markRaw(this.modal.component)
  }

  mounted() {
    this.element = document.getElementById(this.elementId)

    if (!this.element) return

    this.elementHeight = this.element.offsetHeight
    this.elementBottom = 0

    const overlay = document.getElementById(`overlay_${this.elementId}`)
    if (overlay) {
      overlay.style.opacity = '.7'
    }
  }

  onClose() {
    this.elementBottom = -1 * this.elementHeight

    const overlay = document.getElementById(`overlay_${this.elementId}`)
    if (overlay) {
      overlay.style.opacity = '0'
    }

    setTimeout(() => {
      this.removeModal(this.modal)
    }, 500)
  }

  onCloseByOutsideClick() {
    if (this.modal.allowedClickOutSide) {
      this.onClose()
    }
  }
}
